import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        form: '=',
        tasklistTemplate: '=',
        departments: '=',
        roles: '=',
        levels: '='
    },
    template: `
        <form class="person01">
            <div class="alert alert-plain ng-scope" ng-if="vm.form.model.id">
                <p class="ng-binding">{{ 'tasklist.Changes made in the tasklist template do not automatically apply to tasklists already added to employees' | translate }}</p>
            </div>
            <form class="form" ng-submit="vm.save()">
                <form-wrapper form="vm.form">
                    <form-row error="vm.form.errors.name">
                        <label class="label">{{ 'tasklist.Tasklist template name' | translate }}</label>
                        <div class="items">
                            <input ng-model="vm.form.model.name" type="text" class="form-control">
                            <form-row-error></form-row-error>
                        </div>
                    </form-row>
                    <form-row error="vm.form.errors.isAutoAssigned">
                        <label class="label">{{ 'tasklist.Assign automatically' | translate }}</label>
                        <div class="items">
                            <label class="switch01">
                                <input type="checkbox" name="switch" checked="" ng-model="vm.form.model.isAutoAssigned" class="ng-valid ng-dirty ng-valid-parse ng-touched ng-not-empty">
                                <span>Yes</span>
                            </label>
                        </div>
                    </form-row>
                    <form-row ng-if="vm.form.model.isAutoAssigned" error="vm.form.errors.templateTargets">
                        <label class="label">{{ 'tasklist.Target' | translate }}</label>
                        <div class="items">
                            <manage-settings-tasklist-templates-form-target-list
                                ng-if="vm.form.model.isAutoAssigned"
                                targets="vm.form.model.templateTargetsWithValue"
                                form="vm.form"
                                departments="vm.departments"
                                roles="vm.roles"
                                levels="vm.levels"
                                tasklistTemplate="vm.tasklistTemplate"
                            />
                            <p class="desc error" ng-if="vm.form.errors.templateTargets" ng-bind-html="vm.form.errors.templateTargets"></p>
                        </div>
                    </form-row>
                    <form-row ng-if="vm.form.model.isAutoAssigned" error="vm.form.errors.uniqueCondition">
                        <label class="label">{{ 'tasklist.Conditions for automatic assignment' | translate }}</label>
                        <div class="items">
                            <manage-settings-tasklist-templates-form-condition
                                form="vm.form"
                                tasklist-template="vm.tasklistTemplate"
                            />
                            <form-row-error ng-if="vm.form.errors.uniqueCondition"></form-row-error>
                        </div>
                    </form-row>
                    <div ng-if="vm.form.model.isAutoAssigned">
                        <div class="heading01">
                            <h3>{{ 'tasklist.Task completion date' | translate }}</h3>
                        </div>
                        <form-row>
                            <span class="label">{{ 'tasklist.Applies to' | translate }}</span>
                            <div class="items">
                                <ul class="checkboxes">
                                    <li><label><input type="radio" ng-model="vm.form.model.isDeadlineAssignedIndividually" ng-value="0">
                                    {{ 'tasklist.Same value to all tasks' | translate }}</label></li>
                                    <li><label><input type="radio" ng-model="vm.form.model.isDeadlineAssignedIndividually" ng-value="1">
                                    {{ 'tasklist.Individual value to each task' | translate }}</label></li>
                                </ul>
                            </div>
                        </form-row>
                        <form-row ng-if="!vm.form.model.isDeadlineAssignedIndividually" error="vm.form.errors.deadlineType">
                            <span class="label">{{ 'tasklist.Completion deadline' | translate }}</span>
                            <div class="items">
                                <ul class="checkboxes">
                                    <li>
                                        <label><input type="radio" ng-model="vm.form.model.deadlineType" value="CUSTOM"/>{{ 'tasklist.Custom' | translate }}</label>
                                        <label><input type="radio" ng-model="vm.form.model.deadlineType" value="EMPLOYEE_FIRST_DAY"/>{{ 'tasklist.Employees first day of work' | translate }}</label>
                                    </li>
                                </ul>
                                <form-row-error></form-row-error>
                            </div>
                        </form-row>
                        <form-row ng-if="!vm.form.model.isDeadlineAssignedIndividually && vm.form.model.deadlineType==='CUSTOM'"
                            error="vm.form.errors.deadlinePeriod || vm.form.errors.deadlinePeriodType">
                            <label class="label">
                                {{ 'tasklist.Custom completion deadline' | translate }}
                            </label>
                            <div class="items">
                                <input class="form-control small02" ng-model="vm.form.model.deadlinePeriod">
                                <select class="form-control small02"
                                    ng-model="vm.form.model.deadlinePeriodType"
                                    >
                                    <option value="{{ vm.OCCURRENCE_ACCESS_PERIOD_TYPE_ENUM.KEYS.DAY }}">{{ vm.OCCURRENCE_ACCESS_PERIOD_TYPE_ENUM.LABELS.DAY }}</option>
                                    <option value="{{ vm.OCCURRENCE_ACCESS_PERIOD_TYPE_ENUM.KEYS.WEEK }}">{{ vm.OCCURRENCE_ACCESS_PERIOD_TYPE_ENUM.LABELS.WEEK }}</option>
                                    <option value="{{ vm.OCCURRENCE_ACCESS_PERIOD_TYPE_ENUM.KEYS.MONTH }}">{{ vm.OCCURRENCE_ACCESS_PERIOD_TYPE_ENUM.LABELS.MONTH }}</option>
                                </select>
                                <span class="text">{{ 'tasklist.after assignment of tasklist' | translate }}</span>
                                <form-row-error></form-row-error>
                            </div>
                        </form-row>
                    </div>
                    <ul dnd-list="vm.form.model.templateTasks" class="items06 type03">
                        <li ng-repeat="(key, item) in vm.form.model.templateTasks"
                            dnd-draggable="item"
                            dnd-moved="vm.form.model.templateTasks.splice($index, 1)"
                            dnd-effect-allowed="move"
                            dnd-selected="vm.selectedTask = $index"
                            ng-class="{'active': vm.selectedTask === $index, 'error': vm.taskHasError($index)}"
                        >
                            <div class="form">
                                <form-row error="vm.form.errors.templateTasks[key].name">
                                    <label class="label">{{ 'tasklist.Task name' | translate }}</label>
                                    <div class="items">
                                        <input type="text" ng-model="item.name" class="form-control">
                                        <form-row-error></form-row-error>
                                    </div>
                                </form-row>
                                <form-row error="vm.form.errors.templateTasks[key].description">
                                    <label class="label">{{ 'tasklist.Description' | translate }}</label>
                                    <div class="items">
                                        <ng-ckeditor
                                            class="mt10"
                                            ng-model="item.description"
                                            ng-config="vm.ckConfig">
                                        </ng-ckeditor>
                                        <form-row-error></form-row-error>
                                    </div>
                                </form-row>
                                <form-row error="vm.form.errors.templateTasks[key].attachment">
                                    <label class="label">{{ 'tasklist.Attachment' | translate }}</label>
                                    <div class="items">
                                        <input ng-if="!item.fileId" type="file" ngf-select="vm.setFile(key, $file)" ng-model="vm.form.model.templateTasks[key].file" class="form-control">
                                        <div ng-if="item.fileId" class="items">
                                            <a class="btn delete" ng-click="vm.deleteFile(item.id, key)">Delete</a>
                                            <span class="text">
                                                <a ng-click="vm.downloadFile(item.fileId)">{{ item.file.filename }}</a>
                                            </span>
                                        </div>
                                        <form-row-error></form-row-error>
                                    </div>
                                </form-row>
                                <form-row ng-if="vm.form.model.isDeadlineAssignedIndividually" error="vm.form.errors.templateTasks[key].deadlineType">
                                    <span class="label">{{ 'tasklist.Completion deadline' | translate }}</span>
                                    <div class="items">
                                        <ul class="checkboxes">
                                            <li>
                                                <label><input type="radio" ng-model="vm.form.model.templateTasks[key].deadlineType" value="EMPLOYEE_FIRST_DAY"/>
                                                {{ 'tasklist.Employees first day of work' | translate }}</label>
                                                <label><input type="radio" ng-model="vm.form.model.templateTasks[key].deadlineType" value="CUSTOM"/>
                                                {{ 'tasklist.Custom' | translate }}</label>
                                            </li>
                                        </ul>
                                        <form-row-error></form-row-error>
                                    </div>
                                </form-row>
                                <form-row ng-if="vm.form.model.isDeadlineAssignedIndividually && vm.form.model.templateTasks[key].deadlineType==='CUSTOM'"
                                    error="vm.form.errors.templateTasks[key].deadlinePeriod || vm.form.errors.templateTasks[key].deadlinePeriodType">
                                    <label class="label">
                                        {{ 'tasklist.Custom completion deadline' | translate }}
                                    </label>
                                    <div class="items">
                                        <input class="form-control small02" ng-model="vm.form.model.templateTasks[key].deadlinePeriod">
                                        <select class="form-control small02"
                                            ng-model="vm.form.model.templateTasks[key].deadlinePeriodType"
                                            >
                                            <option value="{{ vm.OCCURRENCE_ACCESS_PERIOD_TYPE_ENUM.KEYS.DAY }}">{{ vm.OCCURRENCE_ACCESS_PERIOD_TYPE_ENUM.LABELS.DAY }}</option>
                                            <option value="{{ vm.OCCURRENCE_ACCESS_PERIOD_TYPE_ENUM.KEYS.WEEK }}">{{ vm.OCCURRENCE_ACCESS_PERIOD_TYPE_ENUM.LABELS.WEEK }}</option>
                                            <option value="{{ vm.OCCURRENCE_ACCESS_PERIOD_TYPE_ENUM.KEYS.MONTH }}">{{ vm.OCCURRENCE_ACCESS_PERIOD_TYPE_ENUM.LABELS.MONTH }}</option>
                                        </select>
                                        <span class="text">{{ 'tasklist.after assignment of tasklist' | translate }}</span>
                                        <form-row-error></form-row-error>
                                    </div>
                                </form-row>
                            </div>
                            <a class="btn delete" ng-click="vm.removeTask(key)">{{ 'general.Remove' | translate }}</a>
                        </li>
                    </ul>
                    <ul class="actions01">
                        <li><a class="btn add" ng-click="vm.addTask()">{{ 'tasklist.Add task' | translate }}</a></li>
                    </ul>
                </form-wrapper>
                <button type="submit" class="hidden" >{{ 'tasklist.Save tasklist template' | translate }}</button>
            </form>
        </div>
        <ul class="actions01">
            <li class="primary">
                <a ng-click="vm.save()" class="btn main">
                    {{ 'tasklist.Save tasklist template' | translate }}
                </a>
            </li>
            <li>
                <a ui-sref="authorized.manage.settings.tasklist.templates.list()" class="btn discrete" >
                    {{ 'general.Cancel' | translate }}
                </a>
            </li>
        </ul>
    `
})
export default class {
    constructor ($state, $translate, toastr, lodash, ModalService, CkEditorService, Upload, ResponseService,
        AuthResource, $window, TasklistTemplateResource, FormFactory, OCCURRENCE_ACCESS_PERIOD_TYPE_ENUM) {
        this.$state = $state;
        this.$translate = $translate;
        this.toastr = toastr;
        this.lodash = lodash;
        this.ModalService = ModalService;
        this.CkEditorService = CkEditorService;
        this.Upload = Upload;
        this.ResponseService = ResponseService;
        this.AuthResource = AuthResource;
        this.selectedTask = 0;
        this.$window = $window;
        this.TasklistTemplateResource = TasklistTemplateResource;
        this.ckConfig = this.CkEditorService.getTemplateTaskConfig();
        this.FormFactory = FormFactory;
        this.files = [];
        this.OCCURRENCE_ACCESS_PERIOD_TYPE_ENUM = OCCURRENCE_ACCESS_PERIOD_TYPE_ENUM;
    }

    $onInit () {
        this.setDefaultValues();
    }

    setDefaultValues () {
        if (!this.form.model.templateTargets) {
            this.form.model.templateTargets = [];
        }

        if (!this.form.model.templateTasks) {
            this.form.model.templateTasks = [];
        }

        if (!this.form.model.isDeadlineAssignedIndividually) {
            this.form.model.isDeadlineAssignedIndividually = 0;
        }

        if (!this.form.model.deadlineType) {
            this.form.model.deadlineType = 'CUSTOM';
        }

        if (!this.form.model.deadlinePeriodType) {
            this.form.model.deadlinePeriodType = this.OCCURRENCE_ACCESS_PERIOD_TYPE_ENUM.KEYS.DAY;
        }

        this.form.model.templateTasks.forEach(task => {
            if (!task.deadlineType) {
                task.deadlineType = 'CUSTOM';
            }

            if (!task.deadlinePeriodType) {
                task.deadlinePeriodType = this.OCCURRENCE_ACCESS_PERIOD_TYPE_ENUM.KEYS.DAY;
            }
        });
    }

    downloadFile (id) {
        this.AuthResource
        .requestTacToken().$promise
        .then(({ token }) => {
            const url = `${SEED_CORE.ENV.API_URL}tasklist/template/task-attachment-export?tacToken=${token}&id=${id}`;
            this.$window.open(url);
        });
    }

    deleteFile (id, key) {
        this.TasklistTemplateResource.deleteFile({ id }).$promise.then(() => {
            this.form.model.templateTasks[key].fileId = false;
        });
    }

    setFile (key, file) {
        this.form.model.templateTasks[key].file = file;
    }

    addTask () {
        if (!this.form.model.templateTasks) {
            this.form.model.templateTasks = [];
        }
        this.form.model.templateTasks.push({ name: '', deadlineType: 'EMPLOYEE_FIRST_DAY', deadlinePeriodType: 'DAY' });
        this.selectedTask = this.form.model.templateTasks.length - 1;
    }

    removeTask (index) {
        if (this.form.model.templateTasks.length > 1) {
            const message = this.$translate.instant('tasklist.Are you sure you wish to remove the task?');
            return this.ModalService.delete(message).then(() => {
                this.form.model.templateTasks.splice(index, 1);
            });
        }

        this.toastr.error(this.$translate.instant('tasklist.At least one task is mandatory, task not removed'));
        return false;
    }

    taskHasError (index) {
        return this.lodash.has(this.form.errors, `templateTasks.${index}`)
            && !this.lodash.isEmpty(this.form.errors.templateTasks[index]);
    }

    beforeSave () {
        this.lodash.forEach(this.form.model.templateTasks, (templateTask, index) => {
            this.form.model.templateTasks[index].index = index;
        });

        this.form.model.templateTasks.forEach(task => {
            task.isDeadlineAssignedIndividually = this.form.model.isDeadlineAssignedIndividually;
        });
    }

    savePromise () {
        this.beforeSave();

        let uploadUrl = `${SEED_CORE.ENV.API_URL}tasklist/template`;
        let method = 'POST';

        if (this.tasklistTemplate.id) {
            delete this.form.model.$promise;
            delete this.form.model.$resolved;
            uploadUrl += `/${this.tasklistTemplate.id}`;
            method = 'PUT';
        }

        uploadUrl += '?expand=templateTasks.file,templateTargets,templateTargetsWithValue,templateConditions';

        delete this.form.model.$promise;
        delete this.form.model.$resolved;

        return this.Upload
        .upload({
            url: uploadUrl,
            data: this.form.model,
            method
        });
    }

    save () {
        this.savePromise()
        .then((response) => {
            this.form.errors = [];
            this.form.model = response.data;
            this.setDefaultValues();
            this.form.saved = false;
            this.toastr.success(this.$translate.instant('general.Changes saved'));
            this.tasklistTemplate = response.data;
            this.$state.go('authorized.manage.settings.tasklist.templates.edit', { id: response.data.id });
        }).catch((response) => {
            this.form.errors = this.ResponseService.parseErrors(response);
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/components/manage/settings/tasklist/templates/form/index.js